// extracted by mini-css-extract-plugin
export default {"main_title":"styles_main_title__bmjKj"};